// backup/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './utils/userContext'; // 使用统一的用户上下文
import Auth from './pages/Auth';
import HomePage from './pages/Home';
import Archive from './pages/Archive';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import About from './pages/About';
import NotFound from './pages/NotFound';

// 包装受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { user } = useUser();
  return user ? children : <Navigate to="/login" replace />;
};

// 认证路由组件
const AuthRoute = ({ children }) => {
  const { user } = useUser();
  return user ? <Navigate to="/" replace /> : children;
};

const AppContent = () => {
  const { user, logout } = useUser();

  return (
    <Routes>
      {/* 首页 - 受保护 */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } 
      />
      
      {/* 登录/注册页面 - 认证路由 */}
      <Route 
        path="/login" 
        element={
          <AuthRoute>
            <Auth />
          </AuthRoute>
        } 
      />
      
      {/* 文章归档页面 - 受保护 */}
      <Route 
        path="/archive" 
        element={
          <ProtectedRoute>
            <Archive />
          </ProtectedRoute>
        } 
      />
      
      {/* 文章详情页面 - 受保护 */}
      <Route 
        path="/article/:id" 
        element={
          <ProtectedRoute>
            <PostDetail />
          </ProtectedRoute>
        } 
      />
      
      {/* 写文章页面 - 受保护 */}
      <Route 
        path="/write-post" 
        element={
          <ProtectedRoute>
            <WritePost />
          </ProtectedRoute>
        } 
      />
      
      {/* 关于页面 - 受保护 */}
      <Route 
        path="/about" 
        element={
          <ProtectedRoute>
            <About />
          </ProtectedRoute>
        } 
      />
      
      {/* 404 页面 */}
      <Route 
        path="*" 
        element={<NotFound />} 
      />
    </Routes>
  );
};

const App = () => {
  return (
    <UserProvider>
      <Router>
        <div className="app">
          <AppContent />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;